import { lightBlue } from '@material-ui/core/colors'

/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */

export const debug = false
export const doExperiment = false
export const enableSocket = false
export const allowChunkTouch = false

export let defaultText =
  new URL(window.location.href).searchParams.get('text') ||
  (debug || !doExperiment
    ? `Text selection is typically considered a target acquisition task that defines a range from the start to the end position. The positions are chosen by moving a cursor, and the selected text is highlighted by a caret controlled by two handles. It works well on the desktop because the mouse and keyboard allow for highly precise control of the cursor position. However, target selection with such precision becomes tricky as we move away from the desktop setup. On touchscreens, the touch-based text selection is known to be difficult to perform for users. The well-known fat finger problem causes inaccurate control of the touch position and severe occlusion of the target text. Users have to stop other tasks and stare at a mobile phone. Many methods have been employed to mitigate the difficulty of controlling the caret on touchscreens, such as adding a magnifier, using the keyboard as trackpad, or by tilting the device to control selection, etc. To date, the selection of a chosen text range has largely been fixated on the use of absolute. However, even if the text representation on GUI corresponds to pixel positions, the text itself is composed primarily of syntactic and lexical chunks. So why are we so obsessed about positions, then? Is it possible and useful to select text by focusing more on its primary structures that represent meanings, and less on its representational structures based on positions? This paper treads the first step toward exploring these questions. We propose a conceptual shift for text selection, to support user interaction with its meanings rather than its graphical positioning.`
    : null)

export const wheelTriggerR = 60 // ! minimal distance between trigger and touch
export const wheelCapR = 300 // ! max distance between trigger and touch
export const breakR = 10
export const levelChangeThresholdZoom = 10000 // Incremental trigger

export const expectedSelectTimeSec = 0.2 // sec

export const localhostURL =
  // eslint-disable-next-line no-undef
  new URL(window.location.href).searchParams.get('localhost') || _localhost

export const visualize =
  new URL(window.location.href).searchParams.get('vis') || false ? true : false

let screenPpi
let hardcodedPpi = 150
// if (new URL(window.location.href).searchParams.get('ppi')) {
//   screenPpi = parseInt(new URL(window.location.href).searchParams.get('ppi'))
// } else if (!hardcodedPpi) {
//   RemoteCalibrator.screenSize()
//   screenPpi = RemoteCalibrator.screenPpi
// }
export const ppi = screenPpi || hardcodedPpi

export const slowSpeedCutoff = Math.round((2.5 * ppi) / 2.54) // pix per sec
export const highSpeedCutoff = Math.round((13.5 * ppi) / 2.54) // around 800 px, e.g., 13.5 cm/s

// MAP

export const wordBreakForTouchMap = Math.round((0.2 * ppi) / 2.54) // 15 pix
export const wordBreakForTouch = Math.round((0.9 * ppi) / 2.54) // 50

export const totalBrackets = 3

/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */

export const speedSmoothingCount = 20

/* -------------------------------------------------------------------------- */

// TEMP
export const menuDisabled = true
export const doHardCodeSegmentation = true

export const wheelControls = {
  lr: true,
  tb: false,
}

// For hard-coded things or text, etc.

export const hardcodedExamples = [
  {
    text: 'And so with the sunshine and the great bursts of leaves growing on the trees, just as things grow in fast movies, I had that familiar conviction that life was beginning over again with the summer.',
    lengthsLevels: textArray => ({
      0: Array(textArray.length).fill(1), // WORD
      1: [1, 2, 2, 1, 5, 1, 3, 1, 2, 2, 3, 1, 1, 1, 3, 4, 2, 3, 1],
      2: [3, 2, 1, 5, 4, 1, 2, 5, 1, 2, 3, 4, 5, 1],
      3: [3, 8, 4, 1, 7, 1, 5, 9, 1],
      4: [textArray.length], // SENTENCE
    }),
  },
  {
    text: `Cognitive semantics approaches meaning from the perspective of cognitive linguistics. In this framework, language is explained via general human cognitive abilities rather than a domain-specific language module. Semantics, through modern researchers can be linked to the Wernicke's area of the brain and can be measured using the event-related potential (ERP). ERP is the rapid electrical response recorded with small disc electrodes which are placed on a person's scalp.`,
    lengthsLevels: textArray => ({
      0: Array(textArray.length).fill(1), // WORD,
      1: [
        2, 2, 1, 3, 2, 1, 1, 2, 1, 1, 2, 1, 2, 2, 2, 4, 2, 1, 2, 3, 2, 2, 4, 2,
        2, 1, 3, 2, 4, 3, 1, 1, 1, 2, 2, 2, 3, 2, 2, 5, 1,
      ],
      2: [
        4, 1, 5, 1, 4, 3, 1, 4, 2, 6, 1, 2, 3, 4, 4, 4, 1, 5, 7, 1, 2, 4, 5, 2,
        7, 1,
      ],
      3: [4, 6, 1, 4, 3, 5, 8, 1, 2, 3, 4, 8, 1, 12, 1, 2, 4, 5, 9, 1],
      4: [4, 6, 1, 4, 8, 8, 1, 2, 3, 12, 1, 12, 1, 2, 9, 9, 1],
      5: [11, 4, 16, 1, 2, 15, 13, 1, 11, 9, 1],
      6: [11, 21, 31, 21],
      7: [32, 52],
      8: [textArray.length], // SENTENCE
    }),
  },
]

export const example = hardcodedExamples[1]

export const selectLineStrokeColor = '#C84B31'

// export const levelMin = 0
// export const levelMax = 4
export const levelInit = 0

export const levelChangeThreshold = 1 // Rad

// For random block colors
export const mainColor = [150, 255]
export const otherColor = [50, 200]

/* -------------------------------------------------------------------------- */

export const wheelSize = 120
export const iconHolderSize = 26
export const iconSize = 26

export const wheelBackgroundBaseSize = 120
export const wheelBackgroundBaseOpacity = 0.3

/* -------------------------------------------------------------------------- */

// Adaptive Wheel

export const wheelAdjustSpeedLow = 0
export const wheelAdjustSpeedHigh = 3

export const wheelMaxSize = 120

/* -------------------------------------------------------------------------- */

const startColorLevel = 600
const endColorLevel = 900
// const colors = [lightBlue, purple, orange]
const colors = [lightBlue]

export const getColorTemplate = () => {
  const c = colors[Math.floor(Math.random() * colors.length)]
  return { start: c[startColorLevel], end: c[endColorLevel] }
}

/* -------------------------------------------------------------------------- */

export const dynamicPseudoBlockColor = [10, 10, 10]
